import { EntityProfileTabsLoading } from '../../Entity'
import { Tab } from '../../Tab'
import { Container } from '../Container'

import * as styles from './Tabs.module.css'

function Tabs() {
  return (
    <>
      <Container label='Tab, primary'>
        <Tab text='Tab' />
      </Container>
      <Container label='Tab, primary, long text'>
        <Tab text='Excepteur sint occaecat cupidatat non proident' />
      </Container>
      <Container label='Tab, primary, active/selected'>
        <Tab isActive text='Tab' />
      </Container>
      <Container label='Tab, primary, active/selected, long text'>
        <Tab isActive text='Excepteur sint occaecat cupidatat non proident' />
      </Container>
      <Container label='Tab, primary, disabled'>
        <Tab disabled text='Tab' />
      </Container>
      <Container label='Tab, primary, disabled, long text'>
        <Tab disabled text='Excepteur sint occaecat cupidatat non proident' />
      </Container>
      <Container label='Tab, primary, with count'>
        <Tab count={12} text='Tab' />
      </Container>
      <Container label='Tab, primary, count loading'>
        <Tab isCountLoading text='Tab' />
      </Container>
      <Container
        contentClassName={styles.profileTabsLoading}
        label='Profile tabs loading'
      >
        <EntityProfileTabsLoading />
      </Container>
    </>
  )
}

export default Tabs
